import React, { Component } from "react";
import { Accordion, Table, Image } from "semantic-ui-react";
import _ from "lodash";

class GooglePlusDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0
    };
  }
  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  openwindow = url => window.open(url, "_blank");

  render() {
    const rows = [];
    if (this.props.node !== undefined && this.props.node.length > 0) {
      _.forEach(this.props.node, (person, index) => {
        const name = _.get(person, "displayName[0]._", "");
        rows.push(
          <Table.Row key={`url_row_${index}`}>
            <Table.Cell colSpan={2}>
              <a
                target={"_blank"}
                title={name}
                rel={"noopener noreferrer"}
                href={`${_.get(person, "profileURL[0]._", "")}`}
              >
                {name}
              </a>
            </Table.Cell>
            <Table.Cell>
              <Image src={_.get(person, "photoURL[0]._", "")} />
            </Table.Cell>
          </Table.Row>
        );
      });
    } else {
      rows.push(
        <Table.Row>
          <Table.Cell>No Records Found</Table.Cell>
        </Table.Row>
      );
    }

    return (
      <Accordion fluid styled>
        <Accordion.Title
          active={this.state.activeIndex === 0}
          key={`GooglePlusTitle`}
          onClick={() => this.handleClick()}
        >
          <p>GooglePlus</p>
        </Accordion.Title>
        <Accordion.Content
          key={`GooglePlusBody`}
          active={this.state.activeIndex === 0}
        >
          <Table>
            <Table.Body>{rows}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}
export default GooglePlusDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/GooglePlusDetail.js